<template>
  <div>
    <AppToolbar :title="$t('message.organizations')" :toggle-drawer="true" @toggleDrawer="$emit('toggleDrawer')">
      <template slot="buttons">
        <ToolbarView
          :management-route="{
            name: 'OrganizationList'
          }"
        ></ToolbarView>
      </template>
    </AppToolbar>

    <div v-if="error">
      Error
    </div>

    <div v-if="isLoading" class="mt-3 text-center">
      <v-progress-circular indeterminate size="25" color="primary"></v-progress-circular>
    </div>

    <CollapseMapBtn v-else></CollapseMapBtn>

    <v-card>
      <v-card-text class="sidenav-body pa-0">
        <div v-if="organizations && organizations.length > 0">
          <v-list two-line>
            <template v-for="(organization, index) in organizations">
              <v-divider v-if="index > 0" :key="organization.id"></v-divider>
              <v-list-item
                :key="organization.name"
                @click="
                  $router.push({
                    name: 'OrganizationShowMap',
                    params: { id: $iriToId(organization['@id']) }
                  })
                "
              >
                <v-list-item-avatar>
                  <img
                    v-if="organization.image"
                    :src="organization.image.contentUrl + '?x-request=html'"
                    :alt="organization.name"
                  />
                  <img v-else src="../../assets/no-img.svg" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ organization.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ organization.vessels.length }} vessels</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppToolbar from '@/components/AppToolbar'
import CollapseMapBtn from '@/components/CollapseMapBtn'
import ToolbarView from '@/components/ToolbarView'

export default {
  components: {
    ToolbarView,
    CollapseMapBtn,
    AppToolbar
  },

  computed: mapGetters({
    error: 'organization/list/error',
    organizations: 'organization/list/items',
    isLoading: 'organization/list/isLoading',
    view: 'organization/list/view',
    vessels: 'vessel/list/items'
  }),

  watch: {
    organizations: function(organizations) {
      if (!organizations) {
        return
      }

      this.$emit('setMapVessel', {})
      this.$emit('setMapOrganization', {})
    }
  },

  created() {
    this.$store.commit('mapSetShow', true)
    this.getVesselsPage()
    this.getPage()
  },

  methods: {
    ...mapActions({
      getPage: 'organization/list/default',
      getVesselsPage: 'vessel/list/default'
    })
  }
}
</script>
